import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { Bundle, BundleSummary } from '../lib/catalogTypes';

export function useBundles() {
  return useQuery<BundleSummary[]>({
    queryKey: ['bundles'],
    queryFn: async () => (await api.get<BundleSummary[]>('/bundles')).data,
  });
}

export function useFeaturedBundles() {
  return useQuery<BundleSummary[]>({
    queryKey: ['bundles', 'featured'],
    queryFn: async () => (await api.get<BundleSummary[]>('/bundles/featured')).data,
  });
}

export function useBundle(slug: string) {
  return useQuery<Bundle>({
    queryKey: ['bundles', slug],
    queryFn: async () => (await api.get<Bundle>(`/bundles/${slug}`)).data,
    enabled: !!slug,
  });
}
